module.exports = __webpack_public_path__ + "img/Kewin.001cc0d3.png";